function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.042 4.67l.018.001a.996.996 0 01.428.126l.012.007.02.012a.996.996 0 01.063.04l-.083-.052a1.009 1.009 0 01.35.34l.016.026 5 8.66.015.028c.01.018.02.037.028.056l-.043-.084a1.008 1.008 0 01.134.5v.023l-.003.057.003-.08a1.009 1.009 0 01-.27.684 1.52 1.52 0 01-.117.106.934.934 0 01-.093.065l-.02.011-.03.017a.996.996 0 01-.058.028l.088-.045a1.009 1.009 0 01-.473.134H5.974a.996.996 0 01-.074-.005l.1.005a1.008 1.008 0 01-.473-.118l-.027-.016-.02-.011a1.001 1.001 0 01-.047-.03l.067.041a1.009 1.009 0 01-.458-.577 1.795 1.795 0 01-.025-.106A1.304 1.304 0 015 14.34v-.053l.004-.05L5 14.33a1.008 1.008 0 01.126-.487l.008-.013 5-8.66.014-.024a.996.996 0 01.035-.054l-.049.078a1.008 1.008 0 01.355-.36l.011-.006a.99.99 0 01.077-.04l-.077.04a1.009 1.009 0 01.5-.134h.042zm-.042 3l-3.268 5.66h6.536L11 7.67z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgSmall = function SvgSmall(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22
    }, props), _ref)
  );
};

export default SvgSmall;